module.exports = __webpack_public_path__ + "static/media/final-06.a269b610.svg";